import React from "react"

export function Footer() {

	return (
		<footer>  
			© 2022 Kateryna Kirkwood.   
		</footer>  
	)
}